export default "https://cdn-static.gokick.com/assets/9232f824e6a46c896411df64bf74cb68df4bd809/images/choco-chill.d2e5a3cb4eac031c8a1d2dbef046a05a.png";